<template>
  <!-- BEGIN: Weekly Top Products -->
  <div>
    {{ time }}
    <div class="col-span-5 mt-6">
      <div
        class="intro-y grid grid-cols-3 overflow-auto lg:overflow-visible mt-8 sm:mt-0"
      >
        <table class="table table-report sm:mt-2">
          <thead>
            <tr>
              <th class="whitespace-no-wrap">ID</th>
              <th class="whitespace-no-wrap">WORKSHOP NAME</th>
              <th class="text-center whitespace-no-wrap">STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dat in pending"
              :key="dat.id"
              class="intro-x"
              @click="selectWR(dat)"
            >
              <td>
                <a href="" class="font-medium whitespace-no-wrap">{{
                  dat.id
                }}</a>
              </td>
              <td>
                <a href="" class="font-medium whitespace-no-wrap">{{
                  dat.name
                }}</a>
              </td>
              <td class="w-40">
                <div
                  class="flex items-center justify-center whitespace-no-wrap"
                  :class="{
                    'text-theme-9': dat.p === false,
                    'text-theme-6': dat.p === true,
                  }"
                >
                  <CheckSquareIcon class="w-4 h-4 mr-2" />
                  {{ dat.p ? 'Approved' : 'Pending' }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-span-7">
      <div class="grid grid-cols-1" v-if="model.id">
        <div class="sm:grid grid-cols-2 gap-4">
          <div class="grid grid-cols-1 gap-6 mt-5">
            <div class="intro-y col-span-12 lg:col-span-6">
              <!-- BEGIN: Form Layout -->
              <div class="intro-y box p-5">
                <div>
                  <label>Workshop Name</label>
                  <input
                    v-model="model.name"
                    type="text"
                    class="input w-full border mt-2"
                    placeholder="Input text"
                  />
                </div>
                <div class="mt-3">
                  <label>Category</label>
                  <div class="mt-2">
                    <TailSelect
                      v-model="categories"
                      :options="{
                        hideSelected: true,
                        hideDisabled: true,
                        multiLimit: 15,
                        multiShowCount: false,
                        multiContainer: true,
                        classNames: 'w-full',
                      }"
                      multiple
                    >
                      <option value="Data Science">Data Science</option>
                      <option value="Digital Marketing"
                        >Digital Marketing</option
                      >
                      <option value="Coding">Coding</option>
                      <option value="Tech Business">Tech Business</option>
                      <option value="Others">Others</option>
                    </TailSelect>
                  </div>
                </div>
                <!-- <div class="mt-3">
                <label>Quantity</label>
                <div class="relative mt-2">
                  <input
                    type="text"
                    class="input pr-12 w-full border col-span-4"
                    placeholder="Price"
                  />
                  <div
                    class="absolute top-0 right-0 rounded-r w-10 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                  >
                    pcs
                  </div>
                </div>
              </div> -->
                <!-- <div class="mt-3">
                <label>Weight</label>
                <div class="relative mt-2">
                  <input
                    type="text"
                    class="input pr-16 w-full border col-span-4"
                    placeholder="Price"
                  />
                  <div
                    class="absolute top-0 right-0 rounded-r w-16 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                  >
                    grams
                  </div>
                </div>
              </div> -->
                <div class="mt-3">
                  <!--              <label>Fee</label>-->
                  <div class="sm:grid grid-cols-3 gap-2">
                    <div class="relative mt-2">
                      <div
                        class="absolute top-0 left-0 rounded-l w-12 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                      >
                        Fee
                      </div>
                      <div class="pl-3">
                        <input
                          v-model="model.fees"
                          type="text"
                          class="input pl-12 w-full border col-span-4"
                          placeholder="Amount"
                        />
                      </div>
                    </div>
                    <div class="relative mt-2">
                      <div
                        class="absolute top-0 left-0 rounded-l w-20 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                      >
                        Duration
                      </div>
                      <div class="pl-3">
                        <input
                          v-model="model.duration"
                          type="text"
                          class="input pl-20 w-full border col-span-4"
                          placeholder="Hour(s)"
                        />
                      </div>
                    </div>

                    <!-- <div class="relative mt-2">
                    <div
                      class="absolute top-0 left-0 rounded-l w-12 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                    >
                      Bulk
                    </div>
                    <div class="pl-3">
                      <input
                        type="text"
                        class="input pl-12 w-full border col-span-4"
                        placeholder="Price"
                      />
                    </div>
                  </div> -->
                  </div>
                </div>
                <div class="mt-3">
                  <label>Workshop Date</label>
                  <!--              <LitePicker-->
                  <!--                v-model="salesReportFilter"-->
                  <!--                :options="{-->
                  <!--                  autoApply: false,-->
                  <!--                  showWeekNumbers: true,-->
                  <!--                  dropdowns: {-->
                  <!--                    minYear: 1990,-->
                  <!--                    maxYear: null,-->
                  <!--                    months: true,-->
                  <!--                    years: true-->
                  <!--                  }-->
                  <!--                }"-->
                  <!--                class="input w-full border mt-2"-->
                  <!--              />-->
                  <input
                    type="datetime-local"
                    id="meeting-time"
                    name="meeting-time"
                    v-model="time"
                    class="input w-full border mt-2"
                  />
                </div>
                <!-- <div class="mt-3">
                <label>Active Status</label>
                <div class="mt-2">
                  <input type="checkbox" class="input input--switch border" />
                </div>
              </div> -->
                <div class="mt-5 box p-5">
                  <div class="mt-3">
                    <label>Upload a high resolution image</label>
                    <div
                      class="border-2 border-dashed dark:border-dark-5 rounded-md mt-3 pt-4"
                    >
                      <div class="px-4">
                        <uploader @uploaded="pictureUploaded"></uploader>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 box p-5">
                  <div class="mt-3">
                    <label>Upload course outline</label>
                    <div
                      class="border-2 border-dashed dark:border-dark-5 rounded-md mt-3 pt-4"
                    >
                      <div class="px-4">
                        <uploader @uploaded="courseOutlineUploaded"></uploader>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right mt-5">
                  <button
                    type="button"
                    class="button w-24 border dark:border-dark-5 text-gray-700 dark:text-gray-300 mr-1"
                    @click="model = {}"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="button w-24 bg-theme-1 text-white"
                    @click="submit"
                  >
                    Re-submit
                  </button>
                </div>
                <!--            <FilePond></FilePond>-->
              </div>
              <!-- END: Form Layout -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Weekly Top Products -->
</template>

<script>
import moment from 'moment'
export default {
  props: ['data'],
  data() {
    return {
      time: '',
      selectedWR: {},
      categories: ['Data Science'],
      videolink: '',
      model: {},
      pending: [],
      pending2: [
        { id: '1', name: 'Digital Marketing Analytics Bootcamp', p: true },
        { id: '2', name: 'Mathematics for Kids', p: false },
        { id: '3', name: 'Story Telling through Coding for Kids', p: true },
        { id: '4', name: 'Presentation skill for kids', p: true },
        { id: '5', name: 'Machine learning with python', p: false },
        {
          id: '6',
          name: 'Emotional Intelligence for professional growth',
          p: true,
        },
      ],
    }
  },
  methods: {
    selectWR(data) {
      this.model = data
      console.log(data.workshop_ts)
      this.time = moment(data.workshop_ts * 1000)
        .format(moment.DATETIME_LOCAL)
        .split('+')[0]
      console.log(this.time)
    },
    getWR() {
      this.$upskill.getWR().then((res) => {
        this.pending = res.data.data
      })
    },
    parseTime() {
      let d = new Date(this.time)
      return d.getTime() / 1000
    },
    submit() {
      if (this.isTeacher) {
        if (this.videoLink == '') {
          alert('Work sample video link is mandatory!')
          return
        }
        this.model.description += ` WORK SAMPLE LINK: <a href="${this.videoLink}">Link</a>`
      }
      this.model.categories = this.categories[0]
      this.model.workshop_ts = this.parseTime()
      this.model.fees = this.model.fees * 1.0
      this.model.duration = parseInt(this.model.duration)
      this.$upskill.addWR(this.model).then(() => {
        this.$router.push({ name: 'side-menu-crud-data-list' })
      })
    },
    courseOutlineUploaded(e) {
      this.model.files.push(e.response)
    },
    pictureUploaded(e) {
      this.model.files.push(e.response)
    },
    sampleUploaded(e) {
      console.log(e.response)
    },
  },
  created() {
    this.getWR()
  },
}
</script>
